import gql from 'graphql-tag';

const GET_EXPORT_JOB_STATUS = gql`
  query getExportJobStatus($params: ExportCardTransactionsInput!) {
    exportJobStatus(params: $params) {
      uuid
      s3Bucket
      s3Filename
      exportJobType
      jobCompleted
      createdAt
      merchantName
      venueName

      nextExecutionParameters {
        startDate
        endDate
        cardNetwork
        cardTransactionType
        cardFulfillmentType
        runForDateType
      }
    }
  }
`;

export default GET_EXPORT_JOB_STATUS;
